jQuery(document).ready(function($){

    $('.product-colors li').on('click', function(){
        let color = $(this).attr('data-color');
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');

        $(this).closest('.card-wrapper').find(`.color-image`).removeClass('active');
        $(this).closest('.card-wrapper').find(`.color-image[data-color="${color}"]`).addClass('active');
        
    });
    
});